import React, { useState, useEffect } from "react";
import api from "http";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import Validator, {
  ValidationTypes as V_Type,
} from "react-form-supervalidator";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import {
  MAX_FILE_SIZE_30MB,
  PATIENT_SIDE_PATIENT_PAYMENT_TABS,
  PAYMENT_METHODS,
  TODAY_DATE,
} from "Common/Constants";
import PatientPaymentServiceLines from "./PatientPaymentServiceLines";
import FileAttachmentViewer from "Popups/FileAttachmentViewer/FileAttachmentViewer";
import AddClaimPopup from "Popups/AddClaimPopup/AddClaimPopup";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import { useSelector } from "react-redux";
import { mainTab } from "Redux/TabsSlice/TabsSelectors";
import {
  EXTENSION_NOT_ALLOWED,
  FILE_SIZE_MUST_BE_LESS_THAN_30MB,
  SAVED_SUCCESSFULLY,
} from "Common/ToastConstants";
import ParamListGen from "Services/ParamListGen";
import PaymentDetailsInfoNew from "./PaymentDetailsInfoNew/PaymentDetailsInfoNew";
const URL_PAYMENT = `${process.env.REACT_APP_TC_PMS}/api/Payment`;

const allowedFileTypes = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];
const initialPaymentModel = {
  patientID: null,
  visitId: null,
  paymentMainID: 0,
  amountPaid: null,
  paymentMethod: "",
  checkNumber: "",
  copayDOS: "",
  ccTransactionID: "",
  ccTransactionDate: "",
  notes: "",
  receivedDate: "",
  depositDate: "",
  paidAmount: "",
  patientId: "",
  visitChargePatientPosting: [
    // {
    //   "visitChargeId": null,
    //   "procCode": "",
    //   "dosFrom": "",
    //   "dosTo": "",
    //   "writeOffAmount": null,
    //   "paidAmount": null
    // }
  ],
  paymentAttachment: [],
};
const PatientPaymentDetail = ({
  handlePayment,
  activeTab = null,
  paymentId,
  patientDetail,
  handleReload,
  fetchPaitentHeaderInfo,
  selectedPaymentRow = null,
}) => {
  const mainTabs = useSelector(mainTab);
  const [paymentModel, setPaymentModel] = useState({
    receivedDate: TODAY_DATE,
    stripeSettingId: "",
    locationId: "",
    depositDate: "",
    paymentMethod: PAYMENT_METHODS.CREDIT_CARD,
    checkNumber: "",
    receiptNumber: "",
    copayDOS: TODAY_DATE,
    paymentType: "PATIENT",
    patientId: "",
    addedBy: "",
    amount: "",
    paidAmount: "",
    notes: "",
    isCopay: false,
    paymentSource: [mainTabs.activeTab, activeTab].includes(
      PATIENT_SIDE_PATIENT_PAYMENT_TABS.REQUEST_PAYMENTS
    )
      ? "Payment Request"
      : "Terminal",
    paymentAttachment: [],
  });

  const [state, setState] = useState({
    paymentReceiptPopup: false,
    isLoading: false,
    multiplePatient: false,
    serviceLines: [],
    activePatient: {},
    patientInfo: null,
    addNotes: false,
    claims: [],
    activeClaim: [],
    patientEmail: null,
    patientPhone: null,
    patientSearch: "",
    paymentPopup: false,
    claimLoading: false,
    addClaimPopup: false,
    linkedClaims: [],
    paymentModel: initialPaymentModel,
    activeVisitId: "",
    stripeSettingId: "",
    serviceLoading: false,
    postedAmount: 0,

    selectedClaims: [],
  });

  const [p_Key, setP_Key] = useState("");
  const [editEnable, setEditEnable] = useState(false);
  const [viewAttachment, setViewAttachment] = useState({
    status: false,
    Attachment: 0,
    fileExtension: "",
  });
  const [viewAddAttachmentPopup, setViewAddAttachmentPopup] = useState(false);
  const getPaymentMain = async () => {
    return new Promise((resolve, reject) => {
      setState((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const payload = {
        param_list: ParamListGen({ paymentId }),
        perPage: 10,
        pageNo: 1,
        totalPages: 0,
        totalCount: 0,
      };
      Promise.all([
        api.get(
          `${process.env.REACT_APP_TC_PMS}/api/patientpayment/v2/FindPatientPayment?paymentid=${paymentId}`
        ),
        api.post(URL_PAYMENT + `/FindVisitWisePayments`, payload),
      ])
        .then(async (res) => {
          try {
            const getPatientBalances = await api.get(
              `${process.env.REACT_APP_TC_PMS}/api/Patient/FindPatientHeaderInfoById/${res[0].data.dataModel[0].patientId}`
            );
            if (patientDetail) {
              fetchPaitentHeaderInfo();
            }
            let { patientBalance, patientApplied } =
              getPatientBalances.data.dataModel;
            const { checkRemainingAmount, allocatedAmount } =
              res[0].data.dataModel[0];

            patientApplied = patientApplied || 0;
            patientBalance = patientBalance || 0;

            resolve({
              patientBalance,
              patientApplied,
              checkRemainingAmount,
              allocatedAmount,
              paidAmount: Number(
                res[0].data.dataModel[0].paidAmount || 0
              ).toFixed(2),
            });

            setState({
              ...state,
              paymentPopup: false,
              patientBalance,
              patientApplied,
              checkRemainingAmount,
              allocatedAmount,
              claims: [],
              activeClaim: [],
              activeVisitId: "",
              patientInfo: getPatientBalances.data.dataModel,
              addNotes: !!res[0].data.dataModel[0].notes,
              linkedClaims: res[1].data.dataModel?.data,
              patientSearch:
                patientDetail?.patientName ||
                res[0].data.dataModel[0].patientName,
              postedAmount: res[0]?.data.dataModel[0].postedAmount || 0,
            });
          } catch (error) {
            setState({
              ...state,
              paymentPopup: false,
              addNotes: !!res[0].data.dataModel[0].notes,
              linkedClaims: res[1].data.dataModel,
              patientSearch:
                patientDetail?.patientName ||
                res[0].data.dataModel[0].patientName,
            });
          }
          const paymentData = res[0].data.dataModel[0];
          const rowMatches = selectedPaymentRow?.paymentId === paymentId;
          const isUnpostable =
            paymentData.isUnpostable ??
            paymentData.IsUnpostable ??
            (rowMatches ? selectedPaymentRow?.isUnpostable : undefined);
          setPaymentModel({
            ...paymentData,
            paidAmount: Number(
              paymentData.paidAmount || 0
            ).toFixed(2),
            paymentAttachment: paymentData.paymentAttachment,
            stripeSettingId: paymentData.stripeSettingsId,
            isUnpostable,
          });
        })
        .catch((err) => {
          ErrorHandlingMessage(err);
        })
        .finally(() => {
          setState((prev) => ({
            ...prev,
            isLoading: false,
          }));
        });
    });
  };

  const handleAttachmentChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const allowedAttachments = [];
    for (let i = 0; i < selectedFiles.length; i++) {
      let fileType =
        selectedFiles[i].type || selectedFiles[i].name.split(".")[1];
      if (selectedFiles[i] && allowedFileTypes.includes(fileType)) {
        if (MAX_FILE_SIZE_30MB > selectedFiles[i].size) {
          const reader = new FileReader();
          reader.onload = (event) => {
            allowedAttachments.push({
              addedBy: "",
              updatedBy: "",
              updatedDate: "",
              inActive: false,
              inActiveReason: "",
              inActiveBy: "",
              inActiveDate: "",
              id: 0,
              paymentMainId: 0,
              paymentMain: "",
              fileName: selectedFiles[i].name,
              url: "",
              fileBase64: event.target.result,
            });
            if (allowedAttachments.length === selectedFiles.length) {
              setPaymentModel((prev) => ({
                ...prev,
                paymentAttachment: [
                  ...(Array.isArray(prev.paymentAttachment)
                    ? prev.paymentAttachment
                    : []),
                  ...allowedAttachments,
                ],
              }));
            }
          };
          reader.readAsDataURL(selectedFiles[i]);
        } else {
          toast.warning(FILE_SIZE_MUST_BE_LESS_THAN_30MB);
        }
      } else {
        toast.warning(EXTENSION_NOT_ALLOWED);
      }
    }
  };
  const handleRemoveAttachment = (item, itemIndex) => {
    setPaymentModel((prev) => ({
      ...prev,
      paymentAttachment: paymentModel.paymentAttachment.filter(
        (i, index) => index !== itemIndex
      ),
    }));
  };
  const openViewAttachment = (item, itemIndex) => {
    setViewAttachment((prev) => ({
      ...prev,
      status: true,
      Attachment: paymentModel.paymentAttachment[itemIndex].fileBase64,
      fileExtension: paymentModel.paymentAttachment[itemIndex].fileName?.slice(
        paymentModel.paymentAttachment[itemIndex].fileName.lastIndexOf(".") + 1
      ),
    }));
  };
  const closeViewAttachment = () => {
    setViewAttachment((prev) => ({
      ...prev,
      status: false,
      Attachment: "",
      fileExtension: "",
    }));
  };

  const handleClaimSelect = (claims) => {
    // Add the selected claims to the state (can be single or multiple)
    // No API call needed - they will be linked when posting with visitPaymentId: 0
    const claimsArray = Array.isArray(claims) ? claims : [claims];
    setState((prev) => {
      const newState = {
        ...prev,
        addClaimPopup: false,
        selectedClaims: claimsArray,
      };

      return newState;
    });

    const message =
      claimsArray.length === 1
        ? "Claim added successfully"
        : `${claimsArray.length} claims added successfully`;
    toast.success(message);
  };

  const handleApplyPayment = async () => {
    let validationError = setValidation();
    try {
      if (!validationError) {
        setState((prev) => ({
          ...prev,
          isLoading: true,
        }));
        let response = await api.post(
          `${process.env.REACT_APP_TC_PMS}/api/Payment/SavePaymentMain `,
          paymentModel
        );
        toast.success(SAVED_SUCCESSFULLY);
        setViewAddAttachmentPopup(false);
        await handleReload(response.data.dataModel.paymentMainID, true);
        setEditEnable(false);
        await getPaymentMain();
        // handlePayment(null)
      }
    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setState((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  };

  const handlePaymentChange = (e) => {
    let { name, value } = e.target;
    if (name === "notes" && value.length > 500) {
      value = value.slice(0, 500);
    }
    if (
      name === "paymentMethod" &&
      value === PAYMENT_METHODS.CREDIT_CARD &&
      [mainTabs.activeTab, activeTab].includes(
        PATIENT_SIDE_PATIENT_PAYMENT_TABS.REQUEST_PAYMENTS
      )
    ) {
      setPaymentModel((prev) => ({
        ...prev,
        [name]: value,
        checkNumber: "",
        paymentSource: "Payment Request",
      }));
    } else if (name === "paymentMethod") {
      setPaymentModel((prev) => ({
        ...prev,
        [name]: value,
        checkNumber: "",
        paymentSource: "",
      }));
    } else {
      setPaymentModel((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    if (paymentId) {
      getPaymentMain();
    } else if (patientDetail) {
      setState((prev) => ({
        ...prev,
        patientSearch: patientDetail.patientName,
      }));
      setPaymentModel((prev) => ({
        ...prev,
        patientId: patientDetail.patientId,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentId]);

  const [validationModel, setValidationModel] = useState({
    paymentMethod: null,
    LocationError: null,
    copayDOS: null,
    depositDate: null,
    receivedDate: null,
    paymentSource: null,
    checkNumber: null,
    stripeAccount: null,
    notes: null,
    patientName: null,
    paidAmount: null,
    errorPaymentAttachment: null,
  });

  const setValidation = () => {
    let validationObj = {
      ...validationModel,
      paymentMethod: Validator(
        paymentModel.paymentMethod,
        [V_Type.required],
        ["Payment Method is required"]
      ),
      LocationError: Validator(
        paymentModel.locationId,
        [V_Type.required],
        ["Location is required"]
      ),
      errorPaymentAttachment: viewAddAttachmentPopup
        ? Validator(
          paymentModel.paymentAttachment,
          [V_Type.required],
          ["Attachment is required"]
        )
        : "",
      notes: viewAddAttachmentPopup
        ? Validator(
          paymentModel.notes,
          [V_Type.required],
          ["Notes is required"]
        )
        : "",
      patientName: Validator(
        paymentModel.patientId,
        [V_Type.required],
        ["Patient Name is required"]
      ),
      paidAmount: Validator(
        paymentModel.paidAmount,
        [V_Type.required],
        ["Amount is required"]
      ),
      copayDOS: paymentModel.isCopay
        ? Validator(
          paymentModel.copayDOS,
          [V_Type.required],
          ["Date of Service is required"]
        )
        : "",
      receivedDate: Validator(
        paymentModel.receivedDate,
        [V_Type.required],
        ["Received Date is required"]
      ),
      checkNumber:
        paymentModel.paymentMethod === PAYMENT_METHODS.CHECK
          ? Validator(
            paymentModel.checkNumber,
            [V_Type.required],
            ["Check # is required"]
          )
          : "",
      paymentSource:
        paymentModel.paymentMethod === PAYMENT_METHODS.CREDIT_CARD
          ? Validator(
            paymentModel.paymentSource,
            [V_Type.required],
            ["Payment Source is required"]
          )
          : "",
      stripeAccount: ["Terminal", "Payment Request"].includes(
        paymentModel.paymentSource
      )
        ? Validator(
          paymentModel.stripeSettingId,
          [V_Type.required],
          ["Stripe Account is required"]
        )
        : "",
    };
    if (paymentId && !paymentModel.notes) {
      setState((prev) => ({ ...prev, addNotes: true }));
    }
    setValidationModel(validationObj);
    return Validator(validationObj, V_Type.NullCheck);
  };

  return (
    <>
      {state.isLoading && <FullPageLoader allowFullScreen />}
      {viewAttachment.status && (
        <FileAttachmentViewer
          onClose={closeViewAttachment}
          viewAttachment={viewAttachment}
        />
      )}
      {state.addClaimPopup && (
        <AddClaimPopup
          onClose={() =>
            setState((prev) => ({ ...prev, addClaimPopup: false }))
          }
          handlePaymentDetail={handleClaimSelect}
          patientDetail={{
            patientId: paymentModel.patientId,
            patientName: paymentModel.patientName,
            name: paymentModel.patientName,
          }}
          paymentDetail={paymentModel}
        />
      )}

      <PaymentDetailsInfoNew

        setState={setState}
        handlePayment={handlePayment}
        state={state}
        paymentId={paymentId}
        paymentModel={paymentModel}
        setEditEnable={setEditEnable}
        editEnable={editEnable}
        getPaymentMain={getPaymentMain}
        setPaymentModel={setPaymentModel}
        validationModel={validationModel}
        setValidationModel={setValidationModel}
        handleAttachmentChange={handleAttachmentChange}
        handleRemoveAttachment={handleRemoveAttachment}
        closeViewAttachment={closeViewAttachment}
        openViewAttachment={openViewAttachment}
        handleApplyPayment={handleApplyPayment}
        handlePaymentChange={handlePaymentChange}
        viewAddAttachmentPopup={viewAddAttachmentPopup}
        setViewAddAttachmentPopup={setViewAddAttachmentPopup}
      />
      {!paymentModel.isUnpostable && (
        <div style={{ boxShadow: "0px 2px 48px #0000000A" }} className="mt-6">
          <PatientPaymentServiceLines
            paymentModel={paymentModel}
            paymentId={paymentId}
            setValidation={setValidation}
            getPaymentMain={getPaymentMain}
            setState={setState}
            state={state}
            selectedClaims={state.selectedClaims}
          />
        </div>
      )}

    </>
  );
};

export default PatientPaymentDetail;

PatientPaymentDetail.propTypes = {
  handlePayment: PropTypes.func,
  paymentId: PropTypes.number,
  patientDetail: PropTypes.object,
  handleReload: PropTypes.func,
  selectedPaymentRow: PropTypes.object,
};
